const body = document.querySelector('body')
const toggleMenu = document.querySelector('.toggleBurger')
const navigationDefault = document.querySelector('.headerNavigation')
const headerNavLinks = navigationDefault.querySelectorAll('a')
const firstheaderNavLink = headerNavLinks[0]
const lastheaderNavLink = headerNavLinks[headerNavLinks.length - 1]

// TabIndex
headerNavLinks.forEach(link => {
    link.setAttribute("tabindex", "-1")
})

// Navigation ActiveState
const navPoints = document.querySelectorAll('a.navigationList--item--link')
const getState = (item) => {
    const pathnames = location.pathname.split('/').slice(1)
    const pathKey = item.getAttribute('data-name')
    const isActive = pathnames.includes(pathKey)

    if(isActive) {
        item.closest('li').classList.add('active')
        item.setAttribute("aria-current", "page")
    }

    if(pathnames == '' && pathKey == 'home') {
        item.closest('li').classList.add('active')
        item.setAttribute("aria-current", "page")
    }
}

navPoints.forEach(item => {
    getState(item);
})

// Open/Close Header Navigation
toggleMenu.addEventListener('click', () => {
    toggleMenu.classList.toggle('active')
    navigationDefault.classList.toggle('active')
    body.classList.toggle('no-scroll')

    if(toggleMenu.classList.contains('active')) {
        headerNavLinks.forEach(link => {
            link.setAttribute("tabindex", "0")
        })
        navigationDefault.setAttribute("aria-hidden", "false")
        toggleMenu.setAttribute("aria-label", "Menü schließen")
        toggleMenu.setAttribute("aria-expanded", "true")
        firstheaderNavLink.focus()
    }
    if(!toggleMenu.classList.contains('active')) {
        headerNavLinks.forEach(link => {
            link.setAttribute("tabindex", "-1")
        })
        navigationDefault.setAttribute("aria-hidden", "true")
        toggleMenu.setAttribute("aria-label", "Menü öffnen")
        toggleMenu.setAttribute("aria-expanded", "false")
    }
})

// Tab-Trap im Menü
navigationDefault.addEventListener('keydown', (event) => {
    if (event.key === 'Tab') {
        if (event.shiftKey && document.activeElement === firstheaderNavLink) {
            event.preventDefault()
            toggleMenu.focus()
        } else if (!event.shiftKey && document.activeElement === lastheaderNavLink) {
            event.preventDefault()
            toggleMenu.focus()
        }
    }
})